import styled from 'styled-components';
import { mobileQuery } from '../../utils';
import { ImageUtils } from '../../utils/ImageUtils';

export const Flare = () => {
  return (
    <FlareContainer>
      <Inner style={{ backgroundImage: `url(${ImageUtils.WebFlareImage})` }}></Inner>
    </FlareContainer>
  );
};

const FlareContainer = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 450px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  top: 62px;

  ${mobileQuery} {
    display: none;
  }
`;

const Inner = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 2000px 450px;
  background-repeat: no-repeat;
  background-position: center;
`;
